import React from 'react';
import classes from './block5.module.css';
import img1 from './img.png';
import img2 from './img_1.png';

const Block5 = () => {
    return (
        <div className={classes._} id={'certificates'}>
            <div className={classes.block}>
                <div className={classes.text1}>Подарочный сертификат</div>
                <div className={classes.text2}>Лучшая инвестиция – это инвестиция в себя!<br/>Подари сертификат салона мужской эстетики «Л.Е.В.» и каждый мужчина оценит это по достоинству! Подарочная карта действует на все виды услуг и товаров салона.</div>
                <div className={classes.text3}>Особые условия корпоративным клиентам.</div>
                <div className={classes.text4}>*Через администратора, по номеру телефона салона</div>
                <a href="https://new.sonline.su/deposit-sell/?pid=852816903"
                   className={classes.button}
                   target="_blank"
                   rel="noopener noreferrer">
                    Оформить сертификат
                </a>
                <a className={classes.text5} href={'/offer'} >Правила использования сертификата</a>
            </div>
            <img alt={''} src={img2} className={classes.img2}/>
            <img alt={''} src={img1} className={classes.img1}/>
        </div>
    );
};

export default Block5;